import { motion } from 'framer-motion';
import Head from 'next/head';
import React, { useState } from 'react';

import EmployeesSection from './EmployeesSection';
import RecentSpendingActivity from './RecentSpendingActivity';
import SpendingActivityModal from './SpendingActivityModal';
import TopStats from './TopStats';
import CorporateInviteDrawer from '../CorporateInviteDrawer';
import CorporateLowBalanceBanner from '../CorporateLowBalanceBanner';

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.08,
      delayChildren: 0.05,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 16 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.4,
      ease: [0.25, 0.1, 0.25, 1],
    },
  },
};

const CorporateDashboard: React.FC = () => {
  const [inviteDrawerOpen, setInviteDrawerOpen] = useState(false);
  const [spendingModalOpen, setSpendingModalOpen] = useState(false);
  const [membersRefreshKey, setMembersRefreshKey] = useState(0);

  return (
    <div className='min-h-screen bg-[#050505] text-white flex flex-col'>
      <Head>
        <title>Corporate Dashboard | ZebraLearn Business</title>
      </Head>

      {/* Full-width Low Balance Banner at top */}
      <CorporateLowBalanceBanner />

      {/* Dashboard Main Content */}
      <motion.main
        variants={containerVariants}
        initial='hidden'
        animate='visible'
        className='flex-1 max-w-6xl w-full mx-auto px-4 sm:px-6 py-8 space-y-6'
      >
        {/* Top 3 Metric Cards */}
        <motion.div variants={itemVariants}>
          <TopStats />
        </motion.div>

        {/* Middle Section: Recent Spending Activity */}
        <motion.div variants={itemVariants}>
          <RecentSpendingActivity
            onViewAll={() => setSpendingModalOpen(true)}
          />
        </motion.div>

        {/* Bottom Section: Employees */}
        <motion.div variants={itemVariants}>
          <EmployeesSection
            onOpenInvite={() => setInviteDrawerOpen(true)}
            refreshKey={membersRefreshKey}
          />
        </motion.div>
      </motion.main>

      {/* Slide-out Drawer for Inviting Employees */}
      <CorporateInviteDrawer
        open={inviteDrawerOpen}
        onClose={() => setInviteDrawerOpen(false)}
        onSuccess={() => setMembersRefreshKey((prev) => prev + 1)}
      />

      {/* Modal for All Spending Activity */}
      <SpendingActivityModal
        open={spendingModalOpen}
        onClose={() => setSpendingModalOpen(false)}
      />
    </div>
  );
};

export default CorporateDashboard;
